import store from '@/store'
import I18n from '@/i18n'
import ERROR_CODE from '@/utils/request/error-code'

/**
 * 通用错误处理中间件 处理errno!==0 的情况, 返回result
 */
export function errnoMiddleware(request, response) {
  return new Promise((resolve, reject) => {
    response
      .then(result => {
        if (result.errno !== 0) {
          store.commit('TOAST', { msg: result.errmsg, type: 'error' })
          reject(result)
        } else {
          resolve(result)
        }
      })
      .catch(err => {
        console.warn(err)
        reject(err)
      })
  })
}

/**
 * 和 errnoMiddleware 唯一的区别就是 没有toast，返回result
 */
export function errnoSlientMiddleware(request, response) {
  return new Promise((resolve, reject) => {
    response
      .then(result => {
        if (result.errno !== 0) {
          reject(result)
        } else {
          resolve(result)
        }
      })
      .catch(err => {
        console.warn(err)
        reject(err)
      })
  })
}

/**
 * 通用错误处理中间件 处理errno!==0 的情况, 返回result.data
 */
export function errnoDataMiddleware(request, response) {
  return new Promise((resolve, reject) => {
    response
      .then(result => {
        if (result.errno !== 0) {
          store.commit('TOAST', { msg: result.errmsg, type: 'error' })
          reject(result.data || {})
        } else {
          resolve(result.data)
        }
      })
      .catch(err => {
        console.warn(err)
        reject(err)
      })
  })
}

/**
 * 通用错误处理中间件
 * 唯一区别 没有 toast
 */
export function errnoDataSlientMiddleware(request, response) {
  return new Promise((resolve, reject) => {
    response
      .then(result => {
        if (result.errno !== 0) {
          reject(result.data || {})
        } else {
          resolve(result.data)
        }
      })
      .catch(err => {
        console.warn(err)
        reject(err)
      })
  })
}

/**
 * 增加loading遮罩的中间件
 */
export function loadingMiddleware(request, response) {
  return new Promise((resolve, reject) => {
    store.commit('UPDATE_IS_SHOW_LOADING', true)
    response
      .then((...args) => {
        store.commit('UPDATE_IS_SHOW_LOADING', false)
        resolve.apply(null, args)
      })
      .catch((...args) => {
        store.commit('UPDATE_IS_SHOW_LOADING', false)
        reject.apply(null, args)
      })
  })
}

/**
 * 增加网络异常中间件
 */
export function networkErrorMiddleware(request, response) {
  return new Promise(resolve => {
    response
      .then(result => {
        if (typeof result === 'undefined') {
          resolve({ errno: -1, errmsg: I18n._('网络连接失败，请检查网络设置') })
        } else {
          resolve(result)
        }
      })
      .catch(error => {
        console.warn(error)
        if (error.response) {
          // 这里接口 404 的时候 status 是 0，也不知道是为什么...
          const errno = error.response.status !== 0 ? error.response.status : -1
          resolve({
            errno,
            errmsg: `${errno} ${error.response.statusText}`,
          })
        } else {
          resolve({ errno: -1, errmsg: I18n._('网络连接失败，请检查网络设置') })
        }
      })
  })
}
/**
 * 仅用于处理价格管控需求
 * 作用接口：
 * 1. /item/item/updateCombo
 * 2. /item/item/update
 */
export function handleFoodPriceControlMiddleware(request, response) {
  return new Promise((resolve, reject) => {
    response
      .then(result => {
        // 10秒内，触发多次，会返回10003错误码，跟后端确认，符合预期
        if (result.errno === ERROR_CODE.FOOD_PRICE_CONTROL) {
          const data = JSON.parse(result.errmsg)
          store.commit('item/SHOW_FOOD_PRICE_CONTROL_DIALOG', {
            dialogVisible: true,
            risePriceFrequency: data.risePriceFrequency,
            priceIncreases: data.priceIncreases,
          })
          reject(result.data || {})
        } else if (result.errno !== 0) {
          store.commit('TOAST', { msg: result.errmsg, type: 'error' })
          reject(result.data || {})
        } else {
          resolve(result.data)
        }
      })
      .catch(err => {
        console.warn(err)
        reject(err)
      })
  })
}
